import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import useUserDetails from 'utils/hooks/auth/useUserDetails';
import { toggleChangeReporterModal } from 'store/entities/submissionDetail';

import ChangeReporter from './ChangeReporter';

import DescriptionList, {
  Description,
} from 'components/UIComponents/DescriptionList';
import { Column, Row } from 'components/UIComponents/Layout';
import { Content, Heading } from 'components/UIComponents/Typography';
import Button from 'components/UIComponents/Button';
import Tooltip from 'components/UIComponents/Tooltip';
import Icon from "@mdi/react";
import {mdiInformationOutline} from "@mdi/js";

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userId } = useUserDetails();

  const {
    submissionDetail: { obligation = {} },
  } = useSelector(state => state.submissionDetail);

  const {
    institutionDto,
    registryDto,
    datasetDto,
    tableDto,
    reporter,
    externalFollowers,
  } = obligation;

  return (
    <Row variableGap={{ desktop: 8 }} bordered>
      <ChangeReporter />
      <Column size={6}>
        <Heading
          size={6}
          id="obligation-meta-table-name"
          aria-label="Obligation meta table name"
        >
          {t('datagate.external.submissionDetail.label.table')}:{' '}
          {tableDto?.obligation.toUpperCase() ?? ''}
        </Heading>
        <Content>
          <p
            id="obligation-meta-table-description"
            aria-label="Obligation meta table description"
          >
            {tableDto?.description ?? ''}
          </p>
        </Content>
      </Column>
      <Column size={6}>
        <Content>
          <DescriptionList>
            <Description
              id="obligation-meta-institution-name"
              aria-label="Obligation meta institution name"
              field={t('datagate.external.submissionDetail.label.institution')}
              value={institutionDto?.name ?? ''}
            />
            <Description
              id="obligation-meta-registry-name"
              aria-label="Obligation meta registry name"
              field={t('datagate.external.submissionDetail.label.registry')}
              value={registryDto?.name ?? ''}
            />
            <Description
              id="obligation-meta-dataset-name"
              aria-label="Obligation meta dataset name"
              field={t('datagate.external.submissionDetail.label.dataset')}
              value={datasetDto?.name ?? ''}
            />
          </DescriptionList>
        </Content>
        <Content>
          <DescriptionList>
            <Description
                id="obligation-meta-main-user"
                aria-label="Obligation meta main user name"
                field={t('datagate.external.submissionDetail.label.mainUser')}
                value={
                  institutionDto?.mainUser
                      ? `${institutionDto?.mainUser?.firstName} ${institutionDto?.mainUser?.lastName}`
                      : ' '
                }
            />
            <Description
                id="obligation-meta-reporter"
                aria-label="Obligation meta reporter name"
                field={t('datagate.external.submissionDetail.label.reporter')}
                className="mt-2"
                value={
                  <span>
                  {reporter
                      ? `${reporter?.firstName} ${reporter?.lastName}`
                      : ' '}{' '}
                    {userId === institutionDto?.mainUser?.keycloakId && (
                        <Button
                            className="ml-3"
                            color="primary"
                            outlined
                            size="small"
                            style={{marginTop: '-5px'}}
                            onClick={() => dispatch(toggleChangeReporterModal(true))}
                        >
                          {t('datagate.external.submissionDetail.button.reporter')}
                        </Button>
                    )}
                </span>
                }
            />
            <Description
                id="obligation-detail-external-followers"
                aria-label="Obligation detail external followers"
                value={externalFollowers ?? ''}
            field={
            <span style={{ display: 'inline-flex', alignItems: 'baseline', gap: '4px' }}>
              {t('datagate.external.submissionDetail.label.follower')}
                  <Tooltip
                      position="top"
                      html={
                          <div>
                    {t(
                        'datagate.external.submissionDetail.tooltip.followers'
                    )}
                          </div>
                      }
                  >
      <Icon path={mdiInformationOutline} size={0.75} />
    </Tooltip>
  </span>
          }
            />
          </DescriptionList>
        </Content>
      </Column>
    </Row>
);
};
